<template>
  <svg class="cat-svg" role="presentation">
    <use
      :xlink:href="spriteUrl + '#' + symbolId"
      :href="spriteUrl + '#' + symbolId"
    ></use>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatSvg",
  props: {
    spriteUrl: {
      type: [String]
    },
    symbolId: {
      type: [String]
    }
  }
});
</script>
